const app_style ={
    padding:'0',
    
}

export default app_style;